import { Directive, HostListener, Input } from '@angular/core';

import { TrackingLabel } from 'src/app/core/services/tracking/models/tracking-label.enum';
import { TrackingEventDetail } from 'src/app/core/services/tracking/models/tracking-object.interface';

import { TrackingService } from '../tracking.service';

@Directive({
  selector: '[ccTrackClick]',
  standalone: true
})
export class TrackingDirective {
  private data?: TrackingEventDetail;

  public constructor(private readonly trackingService: TrackingService) {}

  @Input('ccTrackClick')
  public set value(value: TrackingEventDetail) {
    this.data = value;
  }

  @HostListener('click', ['$event'])
  public onClick(): void {
    if (this.data) {
      if (TrackingLabel[this.data.label as keyof typeof TrackingLabel]) {
        this.data.label = TrackingLabel[this.data.label as keyof typeof TrackingLabel];
      }
      this.trackingService.trackClick(this.data);
    }
  }
}
